import {BlogLink, OrderType} from './types';

export const enum PositionRequestType {
    Undefined = 0,
    BySymbol = 1,
    BySymbolList = 2,
    ByAssetType = 3,
    OpenPositions = 4,
}

export interface BalanceResponsePayload {
    'Balances': {
        'CashBalance': number, 'CashBalanceTodaysChange': number,
        'MarginBalance': number, 'MarginBalanceTodaysChange': number, 'ShortBalance': number,
        'ShortBalanceTodaysChange': number, 'WithdrawalAmount': number
    },
    'BuyingPower': { 'AvailableFunds': number, 'BP': number, 'PendingTransactions': number },
    MMF?: { 'MMF': number, 'MoneyMarketFundTodaysChange': number },
    'MarginRequirements': {
        'MarginableEquityPercent': number, 'OptionMarginRequirement': number,
        'OtherMarginRequirement': number, 'StockMarginRequirement': number
    },
    'Securities': {
        'BondsAndCDValue': number, 'BondsAndCDValueTodaysChange': number,
        'LongOptionValue': number, 'LongOptionValueTodaysChange': number,
        'LongStockValue': number, 'LongStockValueTodaysChange': number,
        'MutualFundsValue': number, 'MutualFundsValueTodaysChange': number,
        'ShortOptionValue': number, 'ShortOptionValueTodaysChange': number,
        'ShortStockValue': number, 'ShortStockValueTodaysChange': number
    }

}

export interface BalanceResponse {
    ResponseCode: number;
    Payload: BalanceResponsePayload
}

export interface EditOrderRequest {
    OrderId: number;
    AccountId: number;
    SubaccountId: number;
    Price: number | null;
    Stop: number | null;
    OrderType: OrderType;
}

export interface CancelOrderRequest {
    OrderId: number;
    AccountId: number;
    SubaccountId: number;
}

export interface BlogResponse {
    value: BlogLink[];
}